/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_No_GameInputs */

const th_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้เลือกเกม`)
};

const en_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No game chosen.`)
};

const ja_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合が選ばれていません。`)
};

const zh_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择比赛。`)
};

const es_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha elegido ningún partido.`)
};

const pt_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogo escolhido.`)
};

const id_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada pertandingan yang dipilih.`)
};

const fr_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun match choisi.`)
};

const tl_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang napiling laro.`)
};

const vi_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa chọn trận nào.`)
};

const ko_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선택된 경기가 없습니다.`)
};

const de_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Spiel gewählt.`)
};

const ru_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матч не выбран.`)
};

const tr_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maç seçilmedi.`)
};

const it_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna partita selezionata.`)
};

const pl_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie wybrano meczu.`)
};

const uk_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матч не обрано.`)
};

const hi_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई मैच नहीं चुना गया।`)
};

const ar_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُختر مباراة.`)
};

const ms_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada perlawanan dipilih.`)
};

const bn_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোনও খেলা বাছাই করা হয়নি।`)
};

const zh_tw2_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未選擇比賽。`)
};

const zh_hk2_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未選擇比賽。`)
};

const ur_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کوئی میچ نہیں چنا گیا۔`)
};

const fa_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی‌ای برگزیده نشده.`)
};

const sw_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna mchezo uliochaguliwa.`)
};

const nl_video_no_game = /** @type {(inputs: Video_No_GameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen wedstrijd gekozen.`)
};

/**
* | output |
* | --- |
* | "No game chosen." |
*
* @param {Video_No_GameInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_no_game = /** @type {((inputs?: Video_No_GameInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_No_GameInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_no_game(inputs)
	if (locale === "ja") return ja_video_no_game(inputs)
	if (locale === "zh") return zh_video_no_game(inputs)
	if (locale === "es") return es_video_no_game(inputs)
	if (locale === "pt") return pt_video_no_game(inputs)
	if (locale === "id") return id_video_no_game(inputs)
	if (locale === "fr") return fr_video_no_game(inputs)
	if (locale === "tl") return tl_video_no_game(inputs)
	if (locale === "vi") return vi_video_no_game(inputs)
	if (locale === "ko") return ko_video_no_game(inputs)
	if (locale === "de") return de_video_no_game(inputs)
	if (locale === "ru") return ru_video_no_game(inputs)
	if (locale === "tr") return tr_video_no_game(inputs)
	if (locale === "it") return it_video_no_game(inputs)
	if (locale === "pl") return pl_video_no_game(inputs)
	if (locale === "uk") return uk_video_no_game(inputs)
	if (locale === "hi") return hi_video_no_game(inputs)
	if (locale === "ar") return ar_video_no_game(inputs)
	if (locale === "ms") return ms_video_no_game(inputs)
	if (locale === "bn") return bn_video_no_game(inputs)
	if (locale === "zh-TW") return zh_tw2_video_no_game(inputs)
	if (locale === "zh-HK") return zh_hk2_video_no_game(inputs)
	if (locale === "ur") return ur_video_no_game(inputs)
	if (locale === "fa") return fa_video_no_game(inputs)
	if (locale === "sw") return sw_video_no_game(inputs)
	if (locale === "nl") return nl_video_no_game(inputs)
	return en_video_no_game(inputs)
});